__turbopack_context__.v({
  "Hue": "HueControl-module-scss-module__h49LtG__Hue",
});
